export const PencilIcon = ({
  handleIconClick,
  className,
  width = '24',
  height = '24',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={handleIconClick}
    >
      <g clipPath="url(#clip0_1269_20815)">
        <path
          d="M19.3042 20H8.86951"
          strokeWidth="1.04347"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.86953 20H4.69565C4.51115 20 4.33421 19.9267 4.20375 19.7963C4.07329 19.6658 4 19.4889 4 19.3044V15.4183C4.00009 15.234 4.07326 15.0574 4.20348 14.927L14.9269 4.20359C15.0573 4.07323 15.2342 4 15.4186 4C15.603 4 15.7799 4.07323 15.9104 4.20359L19.7964 8.08704C19.9268 8.21749 20 8.39436 20 8.57878C20 8.76319 19.9268 8.94007 19.7964 9.07051L8.86953 20Z"
          strokeWidth="1.04347"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.3478 6.78125L17.2173 11.6508"
          strokeWidth="1.04347"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1269_20815">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
